<template>
    <modal
        class="rich-text-modal"
        title-tag="div"
        header-bg-variant="blue-600"
        header-text-variant="white"
        :no-close-on-backdrop="true"
        :hide-header-close="true"
    >
        <template v-slot:modal-title>
            <div class="rich-text-modal__tabs">
                <button
                    v-if="rteType === RTE_TYPES.NORMAL || rteType === RTE_TYPES.HEADING"
                    class="rich-text-modal__tab"
                    :class="{ [STATE_CLASSES.SELECTED]: rteIsActive }"
                    @click="showRichText"
                >
                    Rich Text
                </button>

                <button
                    class="rich-text-modal__tab"
                    :class="{ [STATE_CLASSES.SELECTED]: htmlIsActive }"
                    @click="showHtml"
                >
                    HTML
                </button>
            </div>
        </template>

        <rich-text-editor
            v-show="rteIsActive"
            ref="rteEditor"
            :input="html"
            :is-active="rteIsActive"
            @output="onOutput"
        />

        <rich-html-editor
            v-show="htmlIsActive"
            ref="htmlEditor"
            :input="html"
            :is-active="htmlIsActive"
            @output="onOutput"
        />

        <template v-slot:modal-footer>
            <button class="rich-text-modal__button rich-text-modal__button--cancel" @click="onCancel">
                Cancel
            </button>

            <button class="rich-text-modal__button rich-text-modal__button--continue" @click="onSave">
                Save
            </button>
        </template>
    </modal>
</template>

<script>
import { mapMutations, mapState } from 'vuex';

import { STATE_CLASSES } from '@/data/constants/classes';
import { HIDE_MODAL } from '@/store/types/mutation-types';
import richTextEditor from './rich-text-editor';
import richHtmlEditor from './rich-html-editor';

export default {
    components: { richTextEditor, richHtmlEditor },

    data() {
        return {
            editor: {},
            elementId: '',
            html: '',
            htmlIsActive: false,
            rteIsActive: true,
            rteType: '',
            RTE_TYPES: {
                NORMAL: 'normal',
                HEADING: 'heading',
                HTML_ONLY: 'htmlOnly',
            },
            STATE_CLASSES,
        };
    },

    computed: {
        ...mapState({
            modal: state => state.page.modal,
        }),

        isHtmlOnly() {
            return this.rteType === 'htmlOnly';
        },
    },

    created() {
        this.init();
    },

    methods: {
        ...mapMutations({
            hideModal: HIDE_MODAL,
        }),

        async init() {
            const { elementId, html, rteType } = this.modal.data;

            this.rteType = rteType;

            if (rteType === this.RTE_TYPES.HTML_ONLY) {
                this.rteIsActive = false;
                this.htmlIsActive = true;
            }

            this.elementId = elementId;
            await this.$nextTick();
            this.html = html;
        },

        onOutput(html) {
            this.html = html;
        },

        showRichText() {
            if (!this.rteIsActive) {
                this.$refs.htmlEditor.onSaveOrLeaveEditor();
                this.rteIsActive = true;
                this.htmlIsActive = false;
            }
        },

        showHtml() {
            if (!this.htmlIsActive) {
                this.$refs.rteEditor.onSaveOrLeaveEditor();
                this.htmlIsActive = true;
                this.rteIsActive = false;
            }
        },

        onSave() {
            if (this.rteIsActive) {
                this.$refs.rteEditor.onSaveOrLeaveEditor();
            } else if (this.htmlIsActive) {
                this.$refs.htmlEditor.onSaveOrLeaveEditor();
            }

            this.$root.$emit('flex::rich-text::save', this.elementId, this.html);
            this.hideModal();
        },

        onCancel() {
            this.hideModal();
        },
    },
};
</script>

<style lang="scss">
.rich-text-modal {
    z-index: 9100;

    &__tabs {
        display: flex;
        margin: 0 0 -1rem 0;
    }

    &__tab {
        background-color: white;
        color: black;
        margin-right: 8px;
        font-size: 14px;
        padding: 8px 20px;
        border-radius: 8px 8px 0 0;
        opacity: 0.75;
        transition: all 0.35s;

        &.#{ $is-selected } {
            margin-bottom: -2px;
            opacity: 1;
        }
    }

    & .modal-body {
        height: 70vh;
        width: 80vw;
    }

    .modal-dialog {
        top: 40%;
        max-width: 90%;
        max-height: 60%;
    }

    .modal-title {
        font-size: 18px;
    }

    // .modal-content {
    //     min-width: 846px;
    //     min-height: 379px;
    // }

    &__loading {
        @extend %center-middle;
    }

    &__error {
        color: $attention-color;
        position: absolute;
        left: 20px;
        font-size: 14px;
    }

    &__button {
        border: 1px solid;
        width: 100px;
        height: 35px;

        &--continue {
            color: var(--form-buttonColor);
            background-color: var(--form-buttonBackgroundColor);
            border: 1px solid var(--form-buttonBorderColor);

            &:hover {
                color: var(--form-buttonHoverColor);
                background-color: var(--form-buttonHoverBackgroundColor);
            }
        }

        &--cancel {
            color: var(--form-altButtonColor);
            background-color: var(--form-altButtonBackgroundColor);
            border: 1px solid var(--form-altButtonBorderColor);

            &:hover {
                color: var(--form-altButtonHoverColor);
                background-color: var(--form-altButtonHoverBackgroundColor);
            }
        }
    }
}
</style>
